export function showNotice(msg) {
    const $flashMsg = $("#flash-msg");

    $("span", $flashMsg).text(msg);
    $flashMsg
        .show()
        .delay(5000)
        .fadeOut(500);
}
